module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7TbCJ"))).then(() => parcelRequire('iDabs'));